"use client";

/* istanbul ignore file */
import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { CreateWaveStep } from "@/types/waves.types";
import CreateWaveFlow from "./CreateWaveFlow";
import CreateWaveLayout from "./CreateWaveLayout";
import CreateWaveStepContent from "./CreateWaveStepContent";
import type { CreateWaveDescriptionHandles } from "./description/CreateWaveDescription";
import { useCreateWaveSubmission } from "./hooks/useCreateWaveSubmission";
import { useWaveConfig } from "./hooks/useWaveConfig";
export default function CreateWave(t0) {
  const $ = _c(23);
  const {
    profile,
    onBack,
    onSuccess
  } = t0;
  const waveConfig = useWaveConfig();
  const {
    config,
    step,
    selectedOutcomeType,
    onStep
  } = waveConfig;
  const descriptionRef = useRef(null);
  let t1;
  if ($[0] !== config || $[1] !== onSuccess) {
    t1 = {
      config,
      descriptionRef,
      onSuccess
    };
    $[0] = config;
    $[1] = onSuccess;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    submitting,
    showDropError,
    onHaveDropToSubmitChange,
    onInlineGroupCreate,
    onComplete
  } = useCreateWaveSubmission(t1);
  let t2;
  if ($[3] !== onStep) {
    t2 = (targetStep, direction) => {
      onStep({
        step: targetStep,
        direction
      });
    };
    $[3] = onStep;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setStep = t2;
  const t3 = `Create Wave ${config.overview.name ? `"${config.overview.name}"` : ""}`;
  const t4 = selectedOutcomeType === null;
  let t5;
  if ($[5] !== onHaveDropToSubmitChange || $[6] !== onInlineGroupCreate || $[7] !== profile || $[8] !== showDropError || $[9] !== waveConfig) {
    t5 = <CreateWaveStepContent controller={waveConfig} profile={profile} descriptionRef={descriptionRef} showDropError={showDropError} onHaveDropToSubmitChange={onHaveDropToSubmitChange} onInlineGroupCreate={onInlineGroupCreate} />;
    $[5] = onHaveDropToSubmitChange;
    $[6] = onInlineGroupCreate;
    $[7] = profile;
    $[8] = showDropError;
    $[9] = waveConfig;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== config || $[12] !== onComplete || $[13] !== setStep || $[14] !== step || $[15] !== submitting || $[16] !== t4 || $[17] !== t5) {
    t6 = <CreateWaveLayout config={config} step={step} showActions={t4} submitting={submitting} setStep={setStep} onComplete={onComplete}>{t5}</CreateWaveLayout>;
    $[11] = config;
    $[12] = onComplete;
    $[13] = setStep;
    $[14] = step;
    $[15] = submitting;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== onBack || $[20] !== t3 || $[21] !== t6) {
    t7 = <CreateWaveFlow title={t3} onBack={onBack}>{t6}</CreateWaveFlow>;
    $[19] = onBack;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}